import {Component, Inject, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TranslationService, VersionUpdateService} from '@emma-labs/shared/angular';
import {ENVIRONMENT, EnvironmentShared, isDev} from '@emma-labs/shared/typescript';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ConfirmationService, FilterService, PrimeNGConfig} from 'primeng/api';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {filter, interval, startWith, Subscription, switchMap} from 'rxjs';

const ONE_MINUTE = 60_000;

@UntilDestroy()
@Component({
  selector: 'em-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [ConfirmDialogModule, RouterOutlet],
})
export class AppComponent implements OnInit {
  constructor(
    private primengConfig: PrimeNGConfig,
    private translate: TranslationService,
    private filterService: FilterService,
    private confirmationService: ConfirmationService,
    private versionUpdateService: VersionUpdateService,
    @Inject(ENVIRONMENT) private environment: EnvironmentShared,
  ) {}

  ngOnInit(): void {
    this.primengConfig.ripple = true;
    if (this.translate.currentLanguageIsFr()) {
      this.primengConfig.setTranslation({
        clear: 'Effacer',
      });
    }

    this.filterService.register('notIn', (value, filter) => !this.filterService.filters['in'](value, filter));

    if (!isDev(this.environment.environment)) {
      this.startVersionCheck();
    }
  }

  private startVersionCheck(): Subscription {
    return interval(ONE_MINUTE)
      .pipe(
        startWith(0),
        switchMap(() => this.versionUpdateService.checkForVersionUpdate()),
        untilDestroyed(this),
        filter((isNewVersion: boolean) => isNewVersion),
      )
      .subscribe(() => {
        const message = this.translate.currentLanguageIsFr()
          ? 'Une nouvelle version est disponible. Veuillez rafraîchir la page pour mettre à jour.'
          : 'A new version is available. Please refresh the page to update.';
        const header = this.translate.currentLanguageIsFr() ? 'Mise à jour requise' : 'Update required';
        const acceptLabel = this.translate.currentLanguageIsFr() ? 'Rafraîchir' : 'Refresh';

        this.confirmationService.confirm({
          message,
          header,
          acceptLabel,
          rejectVisible: false,
          dismissableMask: false,
          closeOnEscape: false,
          accept: () => window.location.reload(),
          reject: () => window.location.reload(),
        });
      });
  }
}
